import React, { useState, useEffect, useRef } from 'react';
import { View, TouchableOpacity, StyleSheet, Text } from "react-native";

import Colors from '../../constants/colors';

import Hoverable from '../../lib/Hoverable';
import MaterialIcon from 'react-native-vector-icons/MaterialIcons';

import { Icon } from '../Icon';
import { Badge } from '../Badge';

/**
 *
 * @param tooltipText String
 * @param disabled Boolean
 * @param name String
 * @param color String
 * @param size Numeric
 * @param disabledIcon Boolean
 * @param style Object
 * @param onDimensionsChange Function
 */

const ButtonIcon = (props) => {
  const [dimensions, setDimensions] = useState(null);
  const [tooltipHover, setTooltipHover] = useState(false)

  useEffect(() => {
    if (props.onDimensionsChange && dimensions) {
      props.onDimensionsChange(dimensions);
    }
  }, [dimensions])

  var container_ref = useRef();

  useEffect(() => {
    if(!props.disabled && !props.inverted) getIconDimensions();
  }, [])

  const getIconDimensions = () => {
    container_ref.current.measure((a, b, width, height, px, py) => {
      // if for icon in table
      if(px > 350) px = px - 30;
      py = py - 75;
      setDimensions({ width, height, px, py });
    });
  }

  if(props.disabled)
    return (
      <View style={[styles.container, props.style && props.style]}>
        <Icon
          tooltipText={props.disabledTooltipText || props.tooltipText}
          name={props.disabledIcon || props.name}
          size={props.size}
          color={props.disabledColor || Colors.side_menu_secondary}
          library={props.library}
          style={[props.rotate && { transform: `rotate(${props.rotate})` }]}
        />
      </View>
    )

  if(props.inverted)
    return (
      <View style={[styles.container, props.style && props.style]}>
        <Hoverable>
          {hover => (
            <TouchableOpacity
              style={{ alignItems: 'center', backgroundColor: props.color, padding: 10, borderRadius: props.size }}
              onPress={() => props.onPress()}>
              <MaterialIcon name={props.name} size={hover ? ( props.sizeHover ? props.sizeHover : props.size + 7 ) : props.size} color={Colors.white}/>
            </TouchableOpacity>
          )}
        </Hoverable>
      </View>
    )

  return (
    <View ref={container_ref} style={[styles.container, props.style && props.style]} >
      <Hoverable>
        {hover => (
          <TouchableOpacity
            style={{alignItems: 'center', paddingLeft: props.paddingLeft, paddingBottom: props.paddingBottom, flexDirection: 'row'}}
            onPress={props.onPress}>
              <View style={{width: 20, alignItems: 'center', justifyContent: 'center'}}>
                <Icon
                  tooltipText={props.tooltipText}
                  name={props.name}
                  size={((props.tooltipText ? tooltipHover : hover) && !props.disabledHover) ? (props.sizeHover ? props.sizeHover : props.size + 7) : props.size }
                  color={((props.tooltipText ? tooltipHover : hover) && !props.disabledHover) ? props.hoverColor || props.color : props.color}
                  library={props.library}
                  style={[props.rotate && { transform: `rotate(${props.rotate})` }]}
                  onChangeHover={(hover) => setTooltipHover(hover)}
                />
                {props.badge &&
                  <View style={[{position: 'absolute', top: 13, left: 10}, hover && {transform: 'scale(1.2) translate(2px, 4px)'}]}>
                    <Badge text={props.badge} style={{backgroundColor: Colors.red}} />
                  </View>
                }
              </View>
              {props.text && <View style={{marginLeft: 5}}>
                <Text
                  style={{
                    fontSize: (props.tooltipText ? tooltipHover : hover) ? 15 : 14,
                    color: (props.tooltipText ? tooltipHover : hover) ? props.hoverColor || props.color : props.color
                  }}
                >
                  {props.text}
                </Text>
              </View>}
          </TouchableOpacity>
        )}
      </Hoverable>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    marginHorizontal: 10,
    alignItems: 'center',
    justifyContent: 'center',
    height: 20
  }
});

export default ButtonIcon;
